import { BRDGE_PROJECT_ID } from "@/lib/config"
import type { Metric } from "@/lib/types"

export const useOnboardingStore = defineStore(
  `onboarding_${BRDGE_PROJECT_ID}`,
  {
    state: (): {
      completed: boolean
      groupName: string | undefined
      guideId: number | undefined
      votesTopic: Metric | undefined
    } => ({
      completed: false,
      groupName: undefined,
      guideId: undefined,
      votesTopic: undefined
    }),
    actions: {
      complete() {
        this.completed = true
      },
      setGroupName(groupName: string) {
        this.groupName = groupName
      },
      setGuideId(guideId: number) {
        this.guideId = guideId
      },
      setVotesTopic(votesTopic: Metric) {
        this.votesTopic = votesTopic
      }
    },
    persist: {
      storage: persistedState.localStorage
    }
  }
)
